/** Map catalog colour names to swatch hex values */
export const COLOR_SWATCHES = {
  Ivory: "#F5F0E8",
  Espresso: "#3C2A21",
  Sand: "#C4A77D",
  Olive: "#6B6B47",
  Rose: "#C9A9A6",
  Charcoal: "#36454F",
  Cream: "#FFFDD0",
  Stone: "#928E85",
  Camel: "#C19A6B",
};

export const swatchForColor = (color) =>
  COLOR_SWATCHES[color] || "#E8E4DC";
